import { IHttpError } from '@wix/http-client';

export const getQuery = <Result = any>(search = location.search): Result =>
  search
    .replace(/^.*\?/, '')
    .split('&')
    .reduce((acc, param) => {
      const [key, value] = param.split('=').map(decodeURIComponent);

      if (key) {
        acc[key] = value;
      }

      return acc;
    }, {} as Result);

export const generateRandomGuid4 = (): string =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

export const areTrackersEnabled = (): boolean => window.__USE_TRACKERS__;

export const getErrorCode = (reason): number => reason?.code || (reason?.data && reason?.data?.error_code) || 0;

export const shouldReportError = (reason) => {
  const code = getErrorCode(reason);

  const codesToSkip = [
    0, // didn't start
    -7799, // canceled
  ];

  return !codesToSkip.includes(code) && (code < 400 || code >= 500);
};

const isWixHttpError = (error: any): error is IHttpError => {
  return error?.isWixHttpError;
};

type ErrorDetails = {
  requestId?: string;
};

export const extractWixHttpErrorDetails = (error?: unknown): ErrorDetails => {
  if (!(error instanceof Error)) {
    return {};
  }

  if (isWixHttpError(error)) {
    return {
      requestId: error.response?.headers?.['x-wix-request-id'] ?? error.requestId,
    };
  }

  return extractWixHttpErrorDetails(error.cause);
};
